import { render, staticRenderFns } from "./OccurrenceInvolvedAddModal.vue?vue&type=template&id=09774ba2&"
import script from "./OccurrenceInvolvedAddModal.vue?vue&type=script&lang=js&"
export * from "./OccurrenceInvolvedAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports